import React, {ReactNode} from 'react';
import {MultiValueRemoveProps} from 'react-select';

import {RemoveButton} from './RemoveButton';

const noop = () => {
  // do nothing
};

const DEFAULT_CHILDREN = ({
  onClick = noop,
}: {
  onClick?: React.MouseEventHandler<HTMLElement>;
}) => <RemoveButton removeCallback={onClick} />;

interface OwnProps {
  children: (innerProps: JSX.IntrinsicElements['div']) => ReactNode;
}

type Props = OwnProps & MultiValueRemoveProps;

export const DLSelectMultiValueRemove: React.FC<Props> = (props) => {
  const {children = DEFAULT_CHILDREN, innerProps} = props;
  return <div {...innerProps}>{children(innerProps)}</div>;
};

DLSelectMultiValueRemove.displayName = 'DLSelectMultiValueRemove';
